import React, { useEffect, useState } from 'react';
import './user-deactivate-form.scss';
import { ButtonColor } from '@ampol/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { setDeactivateUserButtons } from 'actions/modalMetaActions';
import { adminDeleteUser, deleteUser } from 'actions/userActions';
import ConfirmExitModal from 'features/cards/modals/confirm-exit-modal/confirm-exit-modal';
import Env from 'Env';
import { trackCustomEvent } from 'utilities/app-insights';

/**
 * Form for deactivating user
 * @returns JSX Element
 */
const UserDeactivateForm = ({ userState, onClose }) => {
  const dispatch = useDispatch();

  const isAdminPortal = Env.isAdminPortal();

  const assignedGrandfatherClientNumber = useSelector((state) => state.userStore.assignedGrandfatherClientNumber);
  const userDetails = useSelector((state) => state.userStore.detailedUser);
  const adminUserDetails = useSelector((state) => state.userStore.adminDetailedUser); 
  const assignRolesList = useSelector((state) => state.assignRolesList.roles);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);

  const [showConfirmExitModal, setShowConfirmExitModal] = useState(false);

  const [user, setUser] = useState();
  const [role, setRole] = useState();

  useEffect(() => {
    dispatch(setDeactivateUserButtons({
      onClick: () => setShowConfirmExitModal(true),
    }));

  }, []);
  
  useEffect(() => {
    if ((!isAdminPortal && Object.keys(userDetails).length > 0) || (isAdminPortal && Object.keys(adminUserDetails).length > 0)) {
      setUser(isAdminPortal ? adminUserDetails : userDetails);

      if (!isAdminPortal && userDetails?.assignedClientRoles?.length > 0) {
        const roleId = userDetails.assignedClientRoles.find(x => x.grandfatherClientNumber === assignedGrandfatherClientNumber)?.assignedRoleIds?.[0];
        const roleName = assignRolesList.find(x => x.id === roleId) ? assignRolesList.find(x => x.id === roleId).name : userState?.assignedRoleName;
        
        setRole(roleName);
      }
    } else {
      setUser(userState);
      setRole(userState?.assignedRoleName);
    }
  }, [userDetails]);

  const handleDeleteUser = () => {
    if (isAdminPortal) {
      dispatch(adminDeleteUser(user?.userId));
    } else {
      dispatch(deleteUser(assignedGrandfatherClientNumber, user?.userId));
    }

    trackCustomEvent('Submit Deactivate User', loggedInUser, assignedAccountNumber, 'Clicked Deactivate to submit Deactivate User.', { selectedUserId: user?.userId, selectedUserEmail: user?.emailId });

    onClose();
  };

  return <>
    <div className="user-deactivate-form__deactivate-form-contents">
      <div className="user-deactivate-form__deactivate-form-heading">Are you sure you wish to deactivate this account below?</div>
      <div>
        <div>
          <div>
            <b>Name</b>
          </div>
          <p>{user?.givenName} {user?.familyName}</p>
        </div>
        <div>
          <div>
            <b>Email</b>
          </div>
          <p>{user?.emailId}</p>
        </div>
        {!isAdminPortal &&
          <div>
            <div>
              <b>Role</b>
            </div>
            <p>{role}</p>
          </div>        
        }
      </div>
      {showConfirmExitModal && <ConfirmExitModal 
        title={isAdminPortal ? 'Remove Portal Access' : 'Remove Account Access'}
        content={isAdminPortal
          ? 'Are you sure you wish to remove access to the portal?'
          : 'Are you sure you wish to remove access to this account?'
        }
        color={ButtonColor.Red}
        onConfirmExitClick={handleDeleteUser}
        onClose={() => setShowConfirmExitModal(false)}
      />}
    </div>
  </>;
};

export default UserDeactivateForm;
